"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var composeStore_1 = require("owa-mail-compose-store/lib/store/composeStore");
var folderNameToId_1 = require("owa-session-store/lib/utils/folderNameToId");
var handleBlockActionForShadowMailbox_1 = require("../../actions/helpers/handleBlockActionForShadowMailbox");
var isFolderUnderDeletedFolder_1 = require("owa-mail-store/lib/utils/isFolderUnderDeletedFolder");
var Store_1 = require("owa-mail-list-store/lib/store/Store");
var Store_2 = require("owa-mail-store/lib/store/Store");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var owa_confirm_dialog_1 = require("owa-confirm-dialog");
var owa_strings_1 = require("owa-strings");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var owa_mail_list_store_2 = require("owa-mail-list-store");
var owa_mail_compose_store_1 = require("owa-mail-compose-store");
var owa_mail_search_store_1 = require("owa-mail-search-store");
var legacy_1 = require("satcheljs/lib/legacy");
var bulkTriageConstants_1 = require("owa-mail-store/lib/utils/bulkTriageConstants");
exports.default = legacy_1.select({
    originalTableView: function (conversationId, originalTableViewId) {
        return Store_1.default.tableViews.get(originalTableViewId);
    },
    folderTable: function () { return Store_2.default.folders.folderTable; },
    searchStore: function () { return owa_mail_search_store_1.searchStore; },
})(function deleteMailListRowsHelper(rowKeys, originalTableViewId, isExplicitSoftDelete, deleteRowsInternal, isReplyingToOneOfRows, confirmDialogStrings, state) {
    var originalTableView = state.originalTableView;
    var sourceFolderId = originalTableView.tableQuery.folderId;
    var areRowsUnderDeletedItems;
    var sourceFolderName;
    // Early return if the action is blocked for shadow mailbox
    if (handleBlockActionForShadowMailbox_1.default(sourceFolderId, null)) {
        return null;
    }
    var isSearchTable = originalTableView.tableQuery.type == 1 /* Search */;
    if (isSearchTable) {
        // OW:12312 [Refactor]handle batch conversation triage in search scenarios more elegantly
        // if we are searching in the Deleted Items folder, we want to permanently delete
        areRowsUnderDeletedItems =
            state.searchStore.staticFolderScopeId == folderNameToId_1.default('deleteditems');
        sourceFolderName = owa_mail_strings_1.default.searchFolderName; // "Search"
    }
    else {
        var sourceFolder = state.folderTable.get(sourceFolderId);
        areRowsUnderDeletedItems =
            sourceFolder.distinguishedFolderId === 'deleteditems' ||
                isFolderUnderDeletedFolder_1.default(sourceFolder);
        sourceFolderName = sourceFolder.DisplayName;
    }
    // Show confirm dialog for all group conversation deletions
    var isSoftDelete = isExplicitSoftDelete ||
        areRowsUnderDeletedItems ||
        originalTableView.tableQuery.type == 2 /* Group */;
    // Calculate whether we're above the selection count threshold in select all mode
    var selectionCountThresholdInSelectAll = rowKeys.length >= bulkTriageConstants_1.NUMBER_OF_SELECTED_ITEMS_THRESHOLD &&
        owa_mail_list_store_1.getIsEverythingSelectedInTable(originalTableView);
    /**
     * Determine title of confirmation dialog that'll be shown if we're above the
     * selection count threshold or if we're in a soft delete situation.
     */
    var title = rowKeys.length > 1
        ? owa_strings_1.format(confirmDialogStrings.deleteNumberOfRows, rowKeys.length)
        : owa_mail_strings_1.default.deleteItem;
    var subtext = isSoftDelete
        ? // "Do you want to permanently delete the selected items?"
            confirmDialogStrings.confirmDeleteRows
        : // "Are you sure you want to move all the selected items in [sourceFolderName] to Deleted Items?"
            owa_strings_1.format(owa_mail_strings_1.default.confirmEmptyFolderSubText, owa_mail_strings_1.default.allSelectedItems, sourceFolderName);
    var resolveImmediately = !isSoftDelete && !selectionCountThresholdInSelectAll;
    return owa_confirm_dialog_1.confirm(title, subtext, resolveImmediately /* resolveImmediately */, {
        // Wait until dialog is dismissed to avoid focus interruption
        delayCallbackAfterAnimation: true,
    }).then(function (response) {
        if (response === 0 /* ok */) {
            // Since row may have been deleted from the table while the confirm dialog was open,
            // we need to validate the row keys again before performing delete
            var filteredRowKeys = rowKeys.filter(function (rowKey) {
                var idx = originalTableView.rowKeys.indexOf(rowKey);
                return idx >= 0;
            });
            if (filteredRowKeys.length > 0) {
                deleteRowsIfNotReplying(filteredRowKeys, originalTableView, isSoftDelete ? 'SoftDelete' : 'MoveToDeletedItems', deleteRowsInternal, isReplyingToOneOfRows);
            }
        }
    });
});
/**
 * Proceeds to delete the given rows if user's not replying to one of the rows
 */
function deleteRowsIfNotReplying(rowKeys, originalTableView, disposalType, deleteRowsInternal, isReplyingToOneOfRows) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var rowIdStrings, filteredRowKeys;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    rowIdStrings = owa_mail_list_store_2.getRowIdsFromRowKeys(rowKeys, originalTableView.id);
                    if (!isReplyingToOneOfRows(rowIdStrings)) return [3 /*break*/, 2];
                    return [4 /*yield*/, owa_mail_compose_store_1.lazyDiscardCompose.importAndExecute(composeStore_1.default.defaultViewState)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    // Check isReplyingToOneOfRows for the second time to check the result of user's choice.
                    // If false, it means either
                    //    1. There's no compose for these rows at all, or
                    //    2. There was compose but user chose discard so compose was closed
                    // Then we can continue delete the rows
                    // If true, it means there is compose and user doesn't want to discard it. So we stop deleting now.
                    if (!isReplyingToOneOfRows(rowIdStrings)) {
                        filteredRowKeys = rowKeys.filter(function (rowKey) { return originalTableView.rowKeys.indexOf(rowKey) >= 0; });
                        if (filteredRowKeys.length > 0) {
                            deleteRowsInternal(rowKeys, disposalType);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=deleteMailListRowsHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/helpers/deleteMailListRowsHelper.js
// module id = 3813
// module chunks = 62